import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { GLOBAL } from '../../../services/global';
import { Methods } from '../../methods';

@Injectable({
  providedIn: 'root'
})
export class MailBoxService {
  public mtds: Methods = new Methods();
  public url: string;
  public token;
  public headers: HttpHeaders;

  constructor(private _router: Router, private _http: HttpClient) {
    this.url = GLOBAL.url + '/email/';
    this.token = JSON.parse(localStorage.getItem('token'));
    if (this.token === 'undefined') {
      this.token = null;
    }
    this.headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded',
      'X-Requested-With': 'XMLHttpRequest'
    });
  }

  getAttachmen(json): Observable<any> {
    return this.petition(this.url + 'getattachment', json);
  }

  sendMail(json): Observable<any> {
    return this.petition(GLOBAL.url + '/company/sendemail', json);
  }

  petition(url, json = null, type = null): Observable<any> {
    let params = 'authorization=' + this.token;

    if (json != null) {
      json = encodeURIComponent(JSON.stringify(json));
      params = params + '&json=' + json;
    }

    if (type != null) {
      params = params + '&type=' + type;
    }

    return this._http.post(url, params, { headers: this.headers }).pipe(
      map((res: any) => res),
      catchError(error => {
        if (error.status === 404) {
          this.mtds.notifyError('Your session has expired');
          localStorage.clear();
          this._router.navigate(['/pages/lock']);
        }
        return throwError(error);
      })
    );
  }
}
